declare var LANG: {
  vacancies_found: string,
  vacancies_found_plural: string,
};

import { debounce } from 'lodash';
import toast from './toast';
const formSerialize = require('form-serialize');

const $vacanciesWrapper = $('.js-vacancies');
const $form = $('[data-vacancies="form"]');
const $pageInput: any = $('[data-vacancies="page-input"]');
const $output = $('[data-vacancies="output"]');
const $pagination = $('[data-vacancies="pagination"]');
const $count = $('[data-vacancies="count"]');
const $loader = $('[data-vacancies="loader"]');
const API : string = $vacanciesWrapper.data('vacancies-api');

let page: number = parseInt($pageInput.val(), 10);

const vacanciesFilter = {
  initialize(): void {
    this.createListeners();
  },

  createListeners(): void {
    // For checkboxes we've a small debounce for other JS behaviour to finish up
    const debouncedFilter: Function = debounce(this.filter.bind(this), 50);

    // For search we've a larger debounce because user don't type that fast
    const debouncedSearchFilter: Function = debounce(this.filter.bind(this), 250);

    $form.on('change', 'input[type="checkbox"], input[type="radio"]', () => {
      debouncedFilter();
    });

    $form.on('keyup', 'input[type="text"], input[type="search"]', () => {
      debouncedSearchFilter();
    });

    $form.on('change', 'select', () => {
      this.filter();
    });

    $pagination.on('click', 'a', (e) => {
      e.preventDefault();
      const className = e.currentTarget.className;

      if (className.indexOf('js-next') >= 0) {
        page = page + 1;
      } else if (className.indexOf('js-prev') >= 0) {
        page = page - 1;
      } else if (className.indexOf('js-page') >= 0) {
        const clickedPageNumber = parseInt($(e.currentTarget).data('page'), 10);
        page = clickedPageNumber;
      }

      $pageInput.val(page);

      this.filter();
    });
  },

  filter(): void {
    const form: any = $form[0];
    const serialized: string = formSerialize(form, { hash: false });
    const serializedHashed: object = formSerialize(form, { hash: true });

    this.outputToURL(serialized);

    this.toggleLoader('show');

    $.ajax({
      url: `${API}`,
      type: 'POST',
      data: serializedHashed,
      success: (res) => {
        if (this.validateData(res)) {
          this.outputData(res);
        } else {
          toast('De data die terugkomt uit de API is anders dan verwacht', 3000, 'error');
        }
      },
      error() {
        toast('Er ging iets mis bij het ophalen van de data', 3000, 'error');
      },
    });
  },

  toggleLoader(state: string = 'show'): void {
    $loader.toggleClass('is-visible', state === 'show');
  },

  /**
   * Output query parameters to the URL to keep state during refreshes and navigations
   * @param {string} queryString
   * @return {void}
   */
  outputToURL(queryString: string): void {
    // Check if the History API is available in the browser
    if (typeof window.history === 'undefined' || typeof window.history.replaceState === 'undefined') {
      return;
    }

    window.history.replaceState(null, null, `${API}?${queryString}`);
  },

  /**
   * Validate if the data returned from the API matches my expectations
   * @param {object} res
   * @return {boolean}
   */
  validateData(res: { results: number, html: string }): boolean {
    if (typeof res.results === 'undefined' || typeof res.html === 'undefined') {
      return false;
    }

    return true;
  },

  /**
   * Output data to the DOM
   * @param {object} res
   * @return {void}
   */
  outputData(res: { results: number, html: string }): void {
    const { html, results } = res;
    const $html = $(html);
    const $fetchedOutput = $html.find('[data-vacancies="output"]');
    const $fetchedPagination = $html.find('[data-vacancies="pagination"]');

    $count.html(LANG[results === 1 ? 'vacancies_found' : 'vacancies_found_plural'].replace('%s', results.toString()));
    $output.html($fetchedOutput.html());
    $pagination.html($fetchedPagination.html());

    this.toggleLoader('hide');
  },
};

export default vacanciesFilter;
